import { useEffect } from "react";
import { customEvaluations } from "../../../evaluations";
import { StyledLabelWrapper } from "../../../../../utils/styled";
import type { RenderCustomFieldProps } from "../../../../../types";
import { getGLCalendarIsPostingMonthActiveLabels } from "../../../helpers";

export default function RenderGLCalendarPostingMonthActiveLabels({
  propertyKey,
  propertySubKey,
  rowIndex,
  inputValue,
  evalMethod,
  rowDataReducerState,
  dispatch,
}: Readonly<RenderCustomFieldProps>): JSX.Element {
  const label = getGLCalendarIsPostingMonthActiveLabels({
    rowIndex,
    propertyKey,
    rowData: rowDataReducerState.rowData,
  });

  useEffect(() => {
    if (evalMethod) {
      customEvaluations({
        evalMethod,
        propertyKey,
        propertySubKey,
        rowIndex,
        inputValue: inputValue,
        searchResponse: undefined,
        selectedTabSectionKey: undefined,
        rowDataReducerState,
        dispatch,
      });
    }
  }, []);

  return <StyledLabelWrapper>{label}</StyledLabelWrapper>;
}
